export default __webpack_public_path__ + "static/media/woman.16900991.svg";